import type {
	Components,
} from '@mui/material'

export const materialUIFormControlTheme: {
	components: Components
} = {
	components: {
		MuiFormControl: {
			styleOverrides: {
				root: {
				},
			},
		},
		MuiFormHelperText: {
			styleOverrides: {
				root: {
				},
			},
		},
	},
}
